import { getLoginUrl } from '@buffer-mono/shared-utils/urls'

function getSameOriginRedirectUrl(pathWithSearch: string): URL {
  const redirectUrl = new URL(pathWithSearch, window.location.origin)

  return redirectUrl.origin === window.location.origin
    ? redirectUrl
    : new URL('/', window.location.origin)
}

function getAuthUrlForRedirectPath(
  authPath: 'login' | 'signup',
  pathWithSearch: string,
): string {
  const authUrl = new URL(getLoginUrl(window.location.href))
  authUrl.pathname = `/${authPath}`
  authUrl.searchParams.set(
    'redirect',
    getSameOriginRedirectUrl(pathWithSearch).href,
  )

  return authUrl.href
}

export function getLoginUrlForRedirectPath(pathWithSearch: string): string {
  return getAuthUrlForRedirectPath('login', pathWithSearch)
}

export function getSignupUrlForRedirectPath(pathWithSearch: string): string {
  return getAuthUrlForRedirectPath('signup', pathWithSearch)
}
